import React from 'react';

// import about data
import { doaData } from '../data';

const Aboutdoa = () => {
  // destructure about
  const { image } = doaData;
  return (
    <section
      id='about'
      className='my-[30px] pt-[50px] xl:mt-[100px]'
      data-aos='fade-up'
      data-aos-offset='350'
    >
      <div className='container mx-auto'>
        <div className='bg-accent-about rounded-[50px] min-h-[560px] px-12 pb-12 flex flex-col text-center xl:flex-row xl:items-center xl:text-left  xl:gap-x-[60px] xl:pb-0'>
          {/* image */}
          <div className='flex-1 ml-9' data-aos='zoom-in-left'>
            <img src={image} alt='' />
          </div>
          {/* text */}
          <div className='flex-1 xl:pr-12'>
            <h2 className='h2 mb-10' data-aos='fade-up' data-aos-delay='300'>
            Manfaat memanjatkan doa-doa harian
            </h2>
            <p
              className='max-w-[474px] font-semibold mx-auto xl:mx-0'
              data-aos='fade-up'
              data-aos-delay='400'
            >
              Adanya doa itu diharapkan dapat menyadarkan manusia untuk selalu mengingat Allah sebagai tempat meminta ampunan dan pertolongan. “Doa itu lahir dari sebuah pemahaman, lahir dari sebuah kondisi makna. Allah jadikan manusia itu lemah, lapar, memiliki macam kelemahan untuk menjadi medan ujian bagi kehidupan manusia.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Aboutdoa;
